import { render, staticRenderFns } from "./store-customer.vue?vue&type=template&id=98a2bfd8"
import script from "./store-customer.vue?vue&type=script&lang=js"
export * from "./store-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports